import { Card } from "@amzn/stencil-react-components/card";
import React, { FC } from "react";
import type { PickupBuilding } from "../choose-delivery.types";
import { BuildingSelect } from "./building-select";

export interface PickupPanelProps {
  buildings: PickupBuilding[];
  selectedBuilding?: PickupBuilding;
  onSelectBuilding: (building: PickupBuilding) => void;
}

export const PickupPanel: FC<PickupPanelProps> = ({
  buildings,
  selectedBuilding,
  onSelectBuilding,
}) => (
  <Card width="100%" data-testid="pickup-panel">
    <BuildingSelect
      buildings={buildings}
      selectedBuilding={selectedBuilding}
      onSelect={onSelectBuilding}
    />
  </Card>
);
